import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .required("Please enter name")
      .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
      .min(2, "Name must be at least 2 characters in length")
      .max(50, "Name must be at most 50 characters in length"),
    email: Yup.string()
      .email("The email you have entered is invalid")
      .max(60, "Max length of 60 characters")
      .trim()
      .required("Please enter email"),
    phone_number: Yup.string()
      .required("Please enter phone number")
      .matches(/^[0-9]+$/, "Please enter a valid  phone number")
      .min(10, "Please enter a valid  phone number")
      .max(10, "Please enter a valid  phone number")
  }),
  mapPropsToValues: props => ({
    name: "",
    email: "",
    phone_number: ""
  }),
  handleSubmit: values => {},
  validateOnMount: true,
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
